import { INTEGRATION_PROVIDERS } from '@vy/types';
import { withSuspenseBoundary } from '../../../../../../components/utility/SuspenseBoundary';
import { useQuickbooksEnabled } from '../../../../../../hooks/requests/integrations/quickbooks/use-quickbooks-enabled';
import { useQuickBooksProducts } from '../../../../../../hooks/requests/integrations';
import { ExternalIntegrationProductSelector } from './ExternalIntegrationProductSelector';

const QuickBooksProductSelectorInner: React.FC = () => {
  const isQuickBooksConnected = useQuickbooksEnabled();

  if (!isQuickBooksConnected) {
    return null;
  }

  return (
    <ExternalIntegrationProductSelector
      provider={INTEGRATION_PROVIDERS.quickBooks}
      label="QB ERP ID"
      helperText="Link to your internal ERP system for tracking and reporting"
      placeholder="Select QuickBooks Product"
      useProductsQuery={useQuickBooksProducts}
      data-vy="plan-charge-drawer-qb-input"
    />
  );
};

const QuickBooksProductSelectorWithSuspenseBoundary = withSuspenseBoundary(QuickBooksProductSelectorInner);

export { QuickBooksProductSelectorWithSuspenseBoundary as QuickBooksProductSelector };
